import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getAllTagsList } from '../../actions/admin';
import { useCallback, useEffect } from 'react';
import { debounce } from '../../utils/common';
import Select from '../../common/Form/Select';
import { CLEAR_TAGS_DROPDOWN_LIST_DATA } from '../../types/admin';

const Tags = ({ org_id, name, label, type, required = false, isMulti = false, className }) => {
    const isTagsListLoading = useSelector((state) => state.loading.isTagsListLoading);
    const tagsDropdownList = useSelector((state) => state.admin.tagsDropdownList);
    const dispatch = useDispatch();

    const getTagsList = ({ limit = 100, page = 1, query = '', org_id, type, concat }) => {
        dispatch(getAllTagsList({ type, limit, query, page, concat, dropdown: true, org_id }));
    };

    const debouncedTagsSearchSearch = useCallback(debounce(getTagsList), []);


    useEffect(() => {
        if (org_id) {
            getTagsList({ limit: 100, page: 1, query: '', org_id, type, concat: false });
        }
    }, [org_id]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_TAGS_DROPDOWN_LIST_DATA, payload: type });
        }
    }, [dispatch, type]);

    return <Select
        className={className}
        label={label}
        name={name}
        options={tagsDropdownList}
        required={required}
        isMulti={isMulti}
        isLoading={isTagsListLoading}
        onInputChange={
            (event) => {
                if (event.length > 0) {
                    debouncedTagsSearchSearch({ query: event, type, org_id })
                }
            }
        }
    />;
};

export default Tags;
